import { dataHooks } from '@wix/data-hooks';

export const templateDataHooks = dataHooks<{
  template: { key: string };
}>('template');
